import { render } from "./CountryComparison.vue?vue&type=template&id=b8bcf3ac"
import script from "./CountryComparison.vue?vue&type=script&lang=js"
export * from "./CountryComparison.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__